import React from 'react'
import { object, bool, func } from 'prop-types'

const SplitTerms = ({ text, labelKeys, labels }) => {
  const dotIndex = text.indexOf('.')
  if (dotIndex === -1) return <p>{text}</p>
  const firstPart = text.slice(0, dotIndex + 1).trim()
  const secondPart = text.slice(dotIndex + 1).trim()
  const terms = labelKeys.map(key => labels[key]).join(', ')
  return (
    <>
      <p>{firstPart}</p>
      <p className="modal-text">
        {secondPart} {terms}
      </p>
    </>
  )
}

const AcknowledgmentModal = ({
  handleScroll,
  labels,
  handleAcknowledge,
  scrollButtom
}) => {
  const labelKeys = ['nDI20', 'nDI10', 'nDI75', 'cFONE']
  return (
    <div className="modal-container">
      <div onScroll={handleScroll} className="modal-scroll">
        <SplitTerms
          text={labels.canadianForcesDiscountTerms1}
          labelKeys={labelKeys}
          labels={labels}
        />
        <p className="modal-text">{labels.canadianForcesDiscountTerms2}</p>
        <button
          className="btn btn-primary modal-button"
          disabled={!scrollButtom}
          onClick={handleAcknowledge}
        >
          {labels?.acknowledgeTerms}
        </button>
      </div>
    </div>
  )
}

AcknowledgmentModal.prototype = {
  labels: object.isRequired,
  handleScroll: func.isRequired,
  handleAcknowledge: func.isRequired,
  scrollButtom: bool.isRequired
}

export default AcknowledgmentModal
